export type FieldAlign = "left" | "center" | "right";

export interface FieldSetting {
	x: number;
	y: number;
	width: number;
	font_size: number;
	align?: FieldAlign;
	bold?: boolean;
}

export const FIELD_KEYS = ["client_name", "reference_no", "tin_no", "invoice_date", "address", "terms"] as const;
export type FieldKey = (typeof FIELD_KEYS)[number];

export const ITEM_COLUMN_KEYS = ["quantity", "uom", "description", "unit_price", "amount"] as const;
export type ItemColumnKey = (typeof ITEM_COLUMN_KEYS)[number];

export interface ItemColumnSetting {
	width: number;
	align: FieldAlign;
}

export interface ItemsSetting {
	x: number;
	y: number;
	width: number;
	row_height: number;
	leading_rows: number;
	max_rows: number;
	font_size: number;
	columns: Record<ItemColumnKey, ItemColumnSetting>;
}

export interface SummarySetting {
	x: number;
	y: number;
	width: number;
	row_height: number;
	font_size: number;
}

export interface SignatorySetting {
	name: string;
	x: number;
	y: number;
	width: number;
	font_size?: number;
}

export interface PrintTemplateSettings {
	page: { width: number; height: number; offset_x?: number; offset_y?: number };
	fields: Record<FieldKey, FieldSetting>;
	items: ItemsSetting;
	summary: SummarySetting;
	signatories: SignatorySetting[];
}

export type PageSize = "a4" | "letter" | "legal";
export type Orientation = "portrait" | "landscape";

export interface InvoicePrintTemplate {
	id: string;
	name: string;
	background_path: string | null;
	background_url: string | null;
	page_size: PageSize;
	orientation: Orientation;
	settings: PrintTemplateSettings;
	is_active: boolean;
	created_at?: string;
	updated_at?: string;
}

export interface CreateInvoicePrintTemplateData {
	name: string;
	page_size: PageSize;
	orientation: Orientation;
	settings: PrintTemplateSettings;
}

export type UpdateInvoicePrintTemplateData = Partial<CreateInvoicePrintTemplateData> & { is_active?: boolean };

export const FIELD_LABELS: Record<FieldKey, string> = {
	client_name: "Client Name",
	reference_no: "Reference No.",
	tin_no: "TIN No.",
	invoice_date: "Invoice Date",
	address: "Address",
	terms: "Terms",
};

export const ITEM_COLUMN_LABELS: Record<ItemColumnKey, string> = {
	quantity: "Quantity",
	uom: "UOM",
	description: "Description",
	unit_price: "Unit Price",
	amount: "Amount",
};
